export default {
  data() {
    return {
      isShowMasking: false,
      wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? "",
      btnActive: false,
      hasUploadAppEvent: false
    };
  },
  computed: {
    maskingLang() {
      return {
        one: {
          one: (this.lang === "zh" && "点击右上角的") || "点击右上角的",
          two: (this.lang === "zh" && "按钮") || "按钮"
        },
        two: {
          one: (this.lang === "zh" && "选择") || "选择",
          two: (this.lang === "zh" && "在浏览器中打开") || "在浏览器中打开"
        }
      };
    },
    logoImgs() {
      return {
        blueMenuImageSrc: require("../img/blue-menu.png"),
        blueButtonImageSrc: require("../img/blue-button.png"),
        earthImageSrc: require("../img/earth.png")
      };
    },
    isDingTalk() {
      return navigator.userAgent.toLowerCase().indexOf("dingtalk") !== -1;
    },
    isQQ() {
      return navigator.userAgent.toLowerCase().indexOf("qq/") !== -1;
    },
    isWechat() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    },
    isWownowApp() {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    // 正确的链接
    // ios: superapp://h5.lifekh.com/wakeup?routepath=SuperApp://YumNow/storeDetail?storeNo=MS1430090942563762176
    // andorid: superapp://tinhnow/delivery?url=SuperApp://YumNow/storeDetail?storeNo=MS1430090942563762176
    appRoutePath() {
      let routePath = this.wxGoAppRouter
      // 这里都是解码参数
      if (this.isWownowApp) {
        return `${routePath}`;
      }
      // 编码
      routePath = encodeURIComponent(routePath);
      return `${routePath}`;
    },
    wxGoAppRouter() {
      let routePath =
      this.$root.locationQuery.routePath ||
      this.$root.locationQuery.routepath ||
      `SuperApp://YumNow/storeDetail?storeNo=${this.$root.storeNo}`;
      return `${routePath}`;
    },
  },
  methods: {
    wxClick() {
      if (!this.hasUploadAppEvent) {
        // 埋点
        this.$root.commonUploadEvenlist({
          event: "opeanAppIcon",
          businessName: "拉起APP按钮点击",
          type: "opeanAppIcon"
        });
        this.hasUploadAppEvent = true;
      }
    },
    launchSuccess() {
      console.log("launchSuccess");
    },
    launchError() {
      console.log("launchError");
      this.goApp();
    },
    checkMasking(callback) {
      this.isShowMasking = !!(this.isWechat || this.isDingTalk || this.isQQ);
      typeof callback === "function" && callback(!this.isShowMasking);
    },
    goApp() {
      if (this.$root.isPC) return;
      console.log("this.hasUploadAppEvent", this.hasUploadAppEvent);
      if (!this.hasUploadAppEvent) {
        // 埋点
        this.$root.commonUploadEvenlist({
          event: "opeanAppIcon",
          businessName: "拉起APP按钮点击",
          type: "opeanAppIcon"
        });
        this.hasUploadAppEvent = true;
      }
      this.checkMasking(isOpenClick => {
        if (isOpenClick) {
          this.btnActive = true;
          this.$nextTick(() => {
            const __timeout = setTimeout(() => {
              clearTimeout(__timeout);
              this.btnActive = false;
              this.$nextTick(() => {
                this.goRoutePath();
              });
            }, 100);
          });
        }
      });
    },
    goRoutePath() {
      let fromId = this.$root.locationQuery.fromId;
      console.log("fromId", fromId);
      console.log("this.appRoutePath", this.appRoutePath);
      console.log("this.$root.locationQuery", this.$root.locationQuery);
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        this.$nextTick(() => {
          if (process.env.NODE_ENV === "development") {
            window.location.href = `/wownow/down-loading/index?fromId=${fromId}&routePath=${this.appRoutePath}`;
          } else {
            window.location.href = `/mobile-h5/wownow/down-loading?fromId=${fromId}&routePath=${this.appRoutePath}`;
          }
        });
      }, 1000);
      const preFixRoute =
        (this.$root.isIOS && this.$root.iosUrl) ||
        "superapp://tinhnow/delivery?url=";
      console.log(
        "currentSchemeUrl: ",
        `${preFixRoute}${this.appRoutePath}`
      );
      window.location.href = `${preFixRoute}${this.appRoutePath}`;
    }
  }
};
